import styled from 'styled-components';
import Table from '../table/Table';
import SearchInput from '../search-input/SearchInput';
import Typography from '../typography/Typography';
import { DropdownIcon } from '../assets';
import Button from '../button/Button';
import EmptyState from '../empty-state/EmptyState';
import TableCell from '../table/TableCell';
export const LandingFeesTableContainer = styled.section `
  width: 100%;
  max-width: 90rem;

  border-radius: ${({ theme }) => theme.borderRadius.high};

  overflow: hidden;

  ${({ theme }) => theme.media.tabletL `
    margin-top: 7.2rem;
  `}
`;
export const CustomImg = styled.img `
  width: 1.8rem;
  height: 1.8rem;

  ${({ theme }) => theme.media.tablet `
    width: 3.8rem;
    height: 3.8rem;
  `}
`;
// export const TableHeader = styled.div<JurisdictionProps>`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   text-align: center;
//   width: 100%;
//   padding: 1.6rem 2.7rem;
//   background-color: ${({ theme, isGlobal }) =>
//     isGlobal
//       ? theme.colors.surface.black
//       : theme.colors.interactive.brandColor};
//       background-image: ${({ landingFeesTableMobile }) =>
//         `url(${landingFeesTableMobile})`}
//   background-repeat: no-repeat;
//   background-size: cover;
//   ${({ theme, landingFeesTable }) => theme.media.tabletL`
//     padding: 3rem 3.3rem;
//     text-align: left;
//     justify-content: space-between;
//     background-image: url(${
//       landingFeesTable as unknown as TemplateStringsArray
//     });
//   `}
// `;
export const CustomTable = styled(Table) `
  background-color: ${({ theme }) => theme.colors.surface.default};

  th {
    border-top: 1px solid ${({ theme }) => theme.colors.borders.default};
    border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};
    &:first-child {
      padding-left: 1.3rem;
    }

    &:last-child {
      text-align: left;
    }
  }

  tbody {
    td {
      &:last-child {
        text-align: left;
      }
    }

    tr {
      &:first-child {
        height: 7.7rem;
      }

      &:last-child {
        height: 8rem;
        td {
          padding-bottom: 1.4rem;
        }
      }
    }
  }

  &&& tr {
    border-color: ${({ theme }) => theme.colors.surface.hover};
  }

  ${({ theme }) => theme.media.mobileL `
    th {
      &:first-child {
        padding-left: 2.9rem;
      }
    }

    tbody {
      td {
        &:first-child {
          padding: 1rem 0 1rem 2.9rem;
        }
      }

      tr {
        &:last-child {
          height: 7.7rem;
          td {
            padding-bottom: 1.1rem;
          }
        }
      }
      }
  `}
`;
export const SearchFilter = styled(SearchInput) `
  height: 5.4rem;
  border-radius: 4.8rem;

  ${({ theme }) => theme.media.tabletL `
    max-width: 20rem;  
  `}
`;
export const FeesHeader = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  width: 100%;

  padding: 1.6rem 2.7rem;

  background-color: ${({ theme, isGlobal }) => isGlobal
    ? theme.colors.surface.black
    : theme.colors.interactive.brandColor};
  background-image: ${({ landingFeesTableMobile }) => `url(${landingFeesTableMobile})`}
  background-repeat: no-repeat;
  background-size: cover;
  ${({ theme }) => theme.media.tablet `
    flex-direction: row; 
  `}

  ${({ theme, landingFeesTable }) => theme.media.tabletL `
    padding: 2rem 3.3rem;

    background-image: url(${landingFeesTable});
  `}
`;
export const ExchangeBaseAssetContainer = styled.div `
  display: flex;
  align-items: center;

  margin: 0.5rem 0;

  border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};

  background-color: ${({ theme }) => theme.colors.surface.default};
`;
export const BaseAssetWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.4rem;

  width: 12rem;

  min-width: 7.6rem;

  margin: 0.8rem;
  padding: 0.4rem;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};

  ${({ theme }) => theme.media.tablet `
    padding: 1.6rem 2rem;  
    height: 10.6rem;
    width: 16rem;

    margin: 1.6rem 3.4rem 1.6rem 1.6rem;

     align-items: start;
  `}
`;
export const IconAndTitle = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ theme }) => theme.media.tablet `
   flex-direction: row;
   gap: 1rem;
  `}
`;
export const BaseAssetIconWrapper = styled.div `
  min-width: 1.8rem;
  min-height: 1.8rem;

  ${({ theme }) => theme.media.tablet `
    min-width: 3.8rem
    min-height: 3.8rem;
  `}
`;
export const BaseAssetTitle = styled(Typography) `
  font-size: 1.2rem;
  line-height: 1.8rem;

  ${({ theme }) => theme.media.tablet `
    font-size: 1.4rem;
    line-height: 2rem;
  `}
`;
export const Line = styled.div `
  display: none;
  border: 0.8px solid ${({ theme }) => theme.colors.borders.default};
  width: 100%;

  ${({ theme }) => theme.media.tablet `
    display: block;
    margin: 0.4rem 0;
  `}
`;
export const TypographyForPrice = styled(Typography) `
  align-self: center;
  word-break: break-all;
  ${({ theme }) => theme.media.tablet `
    align-self: start;
  `}
`;
export const QuoteAssetsWrapper = styled.div `
  display: flex;
  flex-direction: column;

  width: 90%;
  height: 100%;
`;
export const AmountTypography = styled(Typography) `
  display: flex;
  justify-content: flex-end;
  flex: 1;
`;
export const FeeTypography = styled(Typography) `
  flex: 1;
  display: flex;
  justify-content: center;
`;
export const QuoteAssetRow = styled.div `
  display: flex;
  align-items: center;

  padding: 2rem 8% 2rem 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.surface.hover};
  }
`;
export const ExchangeIconWrapper = styled.div `
  margin: 0 3%;
  padding-top: 0.3rem;
`;
export const ExchangeData = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
export const TableWrapper = styled.div `
  display: flex;
  flex-direction: column;

  padding-bottom: 1.9rem;

  background-color: ${({ theme }) => theme.colors.surface.default};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.highM};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.highM};
  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  overflow: hidden;
`;
export const ButtonContent = styled.div `
  display: flex;

  align-items: center;
`;
export const CustomDropdownIcon = styled(DropdownIcon) `
  margin-left: 0.5rem;
`;
export const CustomIcon = styled(CustomDropdownIcon) `
  transform: rotate(180deg);
`;
export const ModifiedTableHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;

  min-height: 4.9rem;

  margin-bottom: 1rem;
  padding: 1rem 0.5rem 1.5rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};

  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};

  ${({ theme }) => theme.media.mobileM `
    padding: 1rem 1.5rem 1.5rem 1rem;
  `}

  ${({ theme }) => theme.media.mobileL `
    margin-bottom: 2rem;
    padding: 1rem 3.5rem 1.5rem 1rem;

  `}
`;
export const BaseAssetHeader = styled(Typography) `
  white-space: nowrap;

  padding-left: 0.4rem;
  width: 7rem;
  ${({ theme }) => theme.media.mobileM `
    padding-left: 1.8rem;
  `}
  ${({ theme }) => theme.media.mobileL `
    padding-left: 3rem;
    width: 10rem;
  `}

  ${({ theme }) => theme.media.tablet `
    padding-left: 2.4rem;
      width: 22rem;
  `}
`;
export const MainTableHeaderWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  text-wrap: wrap;

  width: 100%;

  padding-left: 5%;

  ${({ theme }) => theme.media.mobileM `
    padding-left: 12%;
  `}

  ${({ theme }) => theme.media.mobileL `
    padding: 0 2% 0 5%;

  `}

  ${({ theme }) => theme.media.tablet `
    padding: 0 3% 0 6%;
  `}
`;
export const CustomButton = styled(Button) `
  width: auto;

  margin: 1rem 1.5rem 0;
`;
export const CustomEmptyState = styled(EmptyState) `
  height: 35rem;
`;
export const CustomTableCell = styled(TableCell) `
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  & > div:first-child {
    margin-right: 0;
  }

  gap: 0.4rem;
  align-items: center;

  .text-wrapper {
    align-items: center;
  }

  ${({ theme }) => theme.media.tablet `
    flex-direction: row;
    align-items: center;
    & > div:first-child {
      margin-right: 1rem;
    }

    gap: unset;
    align-items: inherit;

  .text-wrapper {
    align-items: inherit;
  }

  `};
`;
export const CustomTypography = styled(Typography) `
  width: 6rem;
  ${({ theme }) => theme.media.tablet `
   width: 8rem;
  `}
`;
export const CustomButtonTypography = styled(Typography) `
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=styles.js.map